const CHUNK_RELOAD_KEY = 'smart_chunk_reload_ts';
const RELOAD_COOLDOWN_MS = 10_000;

/**
 * Detects failed lazy-loaded bundles after a new Amplify deploy (stale tab + new hashes).
 */
export function isChunkLoadError(error) {
  if (!error) return false;
  const name = error?.name;
  const message = String(error?.message ?? error);
  return (
    name === 'ChunkLoadError' ||
    /Loading (CSS )?chunk [\w-]+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message)
  );
}

function isStaticChunkUrl(url) {
  return typeof url === 'string' && /\/static\/(js|css)\/[\w.-]+\.(js|css)/.test(url);
}

/**
 * Full page reload to pick up index.html + new chunk hashes. Cooldown avoids infinite loops.
 */
export function reloadForStaleChunks() {
  const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
  if (last && Date.now() - last < RELOAD_COOLDOWN_MS) {
    return false;
  }
  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
  window.location.reload();
  return true;
}

export function clearChunkReloadCooldown() {
  sessionStorage.removeItem(CHUNK_RELOAD_KEY);
}

/**
 * Register global handlers before React mounts (dynamic import + link/script 404 → HTML).
 */
export function setupChunkLoadRecovery() {
  window.addEventListener('unhandledrejection', (event) => {
    if (!isChunkLoadError(event.reason)) return;
    event.preventDefault();
    reloadForStaleChunks();
  });

  window.addEventListener(
    'error',
    (event) => {
      const target = event.target;
      if (!target || (target.tagName !== 'SCRIPT' && target.tagName !== 'LINK')) {
        return;
      }
      const url = target.src || target.href;
      if (isStaticChunkUrl(url)) {
        reloadForStaleChunks();
      }
    },
    true,
  );
}
